import React from 'react';
import {
  PaymentPeriodHeading, PaymentPeriodOption, PaymentPeriodThumb, PaymentPeriodTrack, PaymentPeriodWrapper,
} from './PaymentTypePeriod.styles';

function PaymentTypePeriod({ selectedType, updateAnswers, error }) {
  const handleChangeType = (type) => {
    updateAnswers({
      payment_frequency: type,
    });
  };

  return (
    <PaymentPeriodWrapper className="form-input-container">
      <PaymentPeriodHeading>Periodicità dei pagamenti</PaymentPeriodHeading>
      <PaymentPeriodTrack>
        <PaymentPeriodThumb $active={selectedType} />
        <PaymentPeriodOption type="button" $active={selectedType === 1} onClick={() => handleChangeType(1)}>
          Annuale
        </PaymentPeriodOption>
        <PaymentPeriodOption type="button" $active={selectedType === 2} onClick={() => handleChangeType(2)}>
          Semestrale
        </PaymentPeriodOption>
      </PaymentPeriodTrack>
      {error && (
        <div className="general-input-error">
          {error}
        </div>
      )}
    </PaymentPeriodWrapper>
  );
}

export default PaymentTypePeriod;
